import { Text } from '@lmn/design-system';
import React from 'react';
import styled from 'styled-components';
import { SubtleButton } from '@/app/components/hotel-detail/common/button';
import { keyUpHandler } from '@/app/components/hotel-detail/common/common.helper';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { EvoSection } from '@/app/components/hotel-detail/evo/EvoCommon';
import ShareButton from '@/app/components/hotel-detail/ShareButton';
import { useFetchHotelStatic } from '@/app/components/hotel-detail/hooks/useFetchHotelStatic';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import { useCommonClient } from '@/app/common/commonClientProvider';
import { Icon } from '@/app/common/icons/Icon';
import { useTranslation } from '../../translations/Translation';

// Desktop-only row above the hero card: back to results on the left, share on the right. Below lg
// the back arrow and the share button are overlaid on the gallery instead, so the row is hidden.
const Container = styled(EvoSection)`
  display: none;
  align-items: center;
  gap: 12px;

  @media ${customCss.breakpoints.lg} {
    display: flex;
    justify-content: space-between;
    padding: 0 0 24px 0;
  }
`;

export function EvoHeroTopBar(props: React.HTMLAttributes<HTMLElement>) {
  const { handleBackToResults } = useCommonClient();
  const { t } = useTranslation();
  const { data: staticData } = useFetchHotelStatic();
  const initialParams = useInitialParams();

  const onGoToResultsClick = () => {
    handleBackToResults();
  };

  return (
    <Container {...props}>
      <SubtleButton
        onClick={onGoToResultsClick}
        onKeyUp={keyUpHandler(onGoToResultsClick)}
        data-testid="goto-results-link"
        css={`
          display: flex;
          align-items: center;
          gap: 8px;
        `}
      >
        <Icon category="Arrows" name="icon-arrow-left" size={20} color="iconPrimary" alt="" />
        <Text variant="Body">{t('vacation.select.cc.back_to_search')}</Text>
      </SubtleButton>
      {!initialParams.isHotelStaticPage && staticData?.name ? (
        <ShareButton hotelName={staticData.name} showText={true} />
      ) : null}
    </Container>
  );
}
